/* IMPORTS */
import React from "react";
import gettext from "../../../shared/utils/gettext";
import "./CorrelationStyling.css";
import { BestCorTypes, CorDetailsTypes } from "./ObjectInterfaces";

/* Assigning the prop types */
interface CorrelationProps {
  correlation: BestCorTypes;
  getDisplayName: any;
  measurementDetails: CorDetailsTypes;
  setCorKeys: any;
  selected: boolean;
}

/* Correlation Component */
export const Correlation = ({
  getDisplayName,
  correlation,
  measurementDetails,
  setCorKeys,
  selected,
}: CorrelationProps) => (
  <div className="card-wrapper js-dataDataset p-2" key={correlation.regular.key}>
    <div className="card" style={{ cursor: "pointer" }}>
      <div
        className="card-body"
        onClick={() =>
          setCorKeys({
            key1: correlation.regular.var1Key,
            key2: correlation.regular.var2Key,
          })
        }
      >
        <div className="card-content container w-100 p-0">
          <div className="row">
            <div className="col-9">
              <span className="font-weight-bold">{`${getDisplayName(
                measurementDetails[correlation.regular.var1Key].code,
                measurementDetails[correlation.regular.var1Key].name
              )}~${getDisplayName(
                measurementDetails[correlation.regular.var2Key].code,
                measurementDetails[correlation.regular.var2Key].name
              )}`}</span>
            </div>
          </div>
          <div className="row small">
            <div className="col-10">
              <p className="no-margin-paragraph">
                {gettext("Correlation") + ": " + correlation.regular.cor}
              </p>
            </div>
            <div className="col-2">
              <i className={`fa fa-chevron-${selected ? "right" : "left"} float-right`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
